import React from 'react';

import { Navigate } from 'react-router-dom';

import ArticleCard from '../ArticleCard';
import Loading from '../Loading';

import { Error } from '../../views';

import { StyledArticleList } from './ArticleList.styled';

const ArticleList = ({ loading, error, data }) => {
  return loading ? (
    <Loading />
  ) : error ? (
    <Error error={error} />
  ) : (
    <StyledArticleList>
      {data.length > 0 ? (
        data.map((article) => (
          <ArticleCard key={article.uid} article={article} />
        ))
      ) : (
        <Navigate to={'/error'} />
      )}
    </StyledArticleList>
  );
};

export default ArticleList;
